const Help = {
  help: 'Help',
  addHelp: 'Add Help',
  editHelp: 'Edit Help',
};
export default Help;
